<template>

    <home-header-component></home-header-component>
    <section id="hero-21" class="bg-snow hero-section division mb-70">
            <Carousel class="row">
                <!--  no link provided -->
                <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">ChatGPT with Creditfixrr.com</span>
                                </h1>
                                <!-- <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">

                                    </span>
                                </p> -->
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📘 3-Step Formula to Use ChatGPT<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        ✂️ Copy-Paste&nbsp;Ready<br>

                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🤯 Includes Detailed Use Cases + Example Outputs<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🔒 1-Time-Payment<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🎁 Bonus: How To Write Perfect Dispute Letter with ChatGPT.
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$19.97</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/2EDh1" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-chatgpt-ebook-right.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide>
                <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">100+ Dispute Reasons</span>
                                </h1>
                                <!-- <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">
                                        Unveil and explore hidden use cases that often go unnoticed by the majority of users.
                                    </span>
                                </p> -->
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🤯 150+ Factual Dispute Reasons<br>

                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        ✂️ Copy-Paste Ready<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        💡 How Guide for Selecting a Dispute Reason.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🔒 1-Time-Payment
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$19.97</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/HbC6A" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-100-dispute-reasons-ebook-right.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide>
                <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">Business Structure & Funding&nbsp;</span>
                                </h1>
                                <!-- <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">

                                    </span>
                                </p> -->
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📘 Ultimate Guide For Structuring & Funding Your Business.<br>

                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🏢 How Correctly Setup Your Business<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🏦 How To Establish Your Business Credit<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🤯 Guide To Getting Funded by the Top 100 Vendors<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🔒 1-Time-Payment
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$49.97</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/bhEaCg" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-business-funding-ebook-right.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide>
                <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">Student Loan Removal Guide</span>
                                </h1>
                                <!-- <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">
                                        Unveil and explore hidden use cases that often go unnoticed by the majority of users.
                                    </span>
                                </p> -->
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        ✂️ How to Remove the Entire Student Loan Account.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🥇 How to Correct Late Payments on Student Loans Accounts.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🥈3-Ways to Deal With Dept. of Education Student Loans.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🥉 What to do when the Credit Bureaus Verify Your Accounts.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🔒 1-Time-Payment<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🎁 Bonus: How To Write Your Student Loan Dispute Letter(s)<br>
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$39.97</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/92Sgo" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-student-loan-removal-ebook-left.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide>
                <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">Dispute Letter Library</span>
                                </h1>
                                <!-- <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">
                                        Unveil and explore hidden use cases that often go unnoticed by the majority of users.
                                    </span>
                                </p> -->
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🤯 150+ Dispute Letters.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        ✂️ Copy-Paste&nbsp;Ready.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📘 Includes: Bankruptcies, Late Payment, Collections, Charge-off Letter(s) + More.<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🔒 1-time payment.
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$29.97</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/cd9Qy" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-dispute-letter-library-ebook-right.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide>
                <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">Creditfixrr.com E-Book Bundle</span>
                                </h1>
                                <!-- <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">
                                        Unveil and explore hidden use cases that often go unnoticed by the majority of users.
                                    </span>
                                </p> -->
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📒 ChatGPT with Creditfixrr<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📘100+ Dispute Reasons<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📗 Business Structure & Funding<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📕 Student Loan Removal Guide<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        📒 Dispute Letter Library<br>
                                    </span>

                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$197.97</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/vZmBd" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/Creditfixrr%20E-book%20Bundle.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide>
                <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">You Are The Creditfixrr Ebook</span>
                                </h1>
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">
                                        <!-- Unveil and explore hidden use cases that often go unnoticed by the majority of users. -->
                                    </span>
                                </p>
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🐣&nbsp;Creditfixrr Software Guide<br>

                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🤯&nbsp;Includes Detailed Use Cases + Example Outputs<br>
                                    </span>
                                    <!-- <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        Includes Notion Template and Video Tutorial<br>
                                    </span> -->
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        🔒&nbsp;One-time payment.
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div 
                                    class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$27.99</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/ykpjo" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-ebook.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>
                    </div>
                </Slide>
                <!-- <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">The Perfect Dispute Letter</span>
                                </h1>
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">
                                        Unveil and explore hidden use cases that often go unnoticed by the majority of users.
                                    </span>
                                </p>
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        &nbsp;750&nbsp;Beginner Friendly&nbsp;Ways to Use ChatGPT<br>

                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        Copy-Paste&nbsp;Ready<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        Includes Notion Template and Video Tutorial<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        One-time payment.
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$197.99</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/HbC6A" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-the-perfect-dispute-letter-ebook-right.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide> -->
                <!-- <Slide class="col-lg-12">
                    <div class="row d-flex align-items-center">
                        <div class="col-lg-8">
                            <div class="hero-21-txt">
                                <h1 style="text-align: left;" data-mce-style="text-align: left;" data-font-size-xs="1.667rem" data-line-height-xs="1.889rem">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">You Are The Creditfixrr</span>
                                </h1>
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;" data-mce-style="color: #4b9a5e;">
                                        Unveil and explore hidden use cases that often go unnoticed by the majority of users.
                                    </span>
                                </p>
                                <p style="text-align: justify!important;">
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        &nbsp;750&nbsp;Beginner Friendly&nbsp;Ways to Use ChatGPT<br>

                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        Copy-Paste&nbsp;Ready<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        Includes Notion Template and Video Tutorial<br>
                                    </span>
                                    <span style="color: #4b9a5e;text-align: justify!important;" data-mce-style="color: #4b9a5e;">
                                        One-time payment.
                                    </span>
                                </p>
                                <div id="content_prize" class="column-content" data-module="text" style="text-align: justify;">
                                    <div class="is-content"><h2><span style="color: #4b9a5e;text-align: justify;" data-mce-style="color: #4b9a5e;">$197.99</span></h2></div>
                                </div>
                                <div id="content_btn" class="column-content" data-module="button">
                                    <div class="ce-button" data-align="left">
                                        <div class="is-content " data-width="grid-width" data-effect="slide-left-to-right" data-icon-direction="right">
                                            <a class="btn" data-font="font_9sv1kvow2" href="https://sowl.co/s/kcrPg" target="_blank" data-text-effect="none" data-text-align="center" style="background: #4b9a5e;width: 100%;color: white;">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-ebook-right.png" class="img-responsive image-center" style="height: 450px;"/>
                        </div>

                    </div>
                </Slide> -->
                <template #addons>
                <Pagination />
                <div style="width: 100%;color: #4b9a5e;font-weight: bolder;">
                    More Ebooks
                </div>
                <!--  -->
                </template>
            </Carousel>
    </section>
    <!-- <section id="features-8" class="pb-20 pt-60 features-section division" style="padding-top: 60px;">
        <div id="howitworks"></div>
            <div class="row justify-content-center">
                <div class="col-lg-10 col-xl-8">
                    <div class="section-title title-01 mb-70">
                        <h2 class="h2-md">What You Receive</h2>
                        <p class="p-xl mb-4" style="padding-bottom: 30px;">Position yourself as an expert in the newly AI-dominated economy with just a few simple chapters..</p>
                        <div class="row mt-4">
                            <div class="col-lg-3">
                                <h3>Advanced Writing</h3>
                                <p>
                                    Write nearly anything using my writing prompts, just as a seasoned professional would.
                                </p>
                            </div>
                            <div class="col-lg-3">
                                <h3>Increasing Productivity</h3>
                                <p>
                                    Maximize your productivity during your busy day with 300 time-saving ChatGPT lines.
                                </p>
                            </div>
                            <div class="col-lg-3">
                                <h3>Discover Ideas</h3>
                                <p>
                                    Kickstart your creative process with prompts that brainstorm, plan, and rethink ideas for you.
                                </p>
                            </div>
                            <div class="col-lg-3">
                                <h3>"Generate Disputes."</h3>
                                <p>
                                    Improve your understanding of how to generate disputes using ChatGPT.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>	 -->
    <!-- END FEATURES-8 -->
    <!-- slider -->
    <footer-component></footer-component>
</template>
<script>
import HomeHeaderComponent from '../HomeHeaderComponent.vue'
import FooterComponent from '../FooterComponent.vue'
import { Carousel, Pagination, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'
import {ref} from 'vue'

export default{
    components:{
        HomeHeaderComponent,
        FooterComponent,
        Carousel,
        Slide,
        Pagination,
    },
    setup(){
        return{
            landing_data: ref({})
        }
    },
    mounted(){

    }
}
</script>
<style>
#content_prize {
    padding-top: 1.1111111111111112rem;
}
.column-content {
    width: 100%;
    position: relative;
 }
 #content_btn{
    padding-top: 1.1111111111111112rem;
    padding-right: 7.777777777777778rem;
    padding-bottom: 2.2222222222222223rem;
}
#content_btn .is-content {
    border-width: 0rem;
    border-radius: 0.2777777777777778rem;
}
.image-center{
    display: block;
    margin-left: auto;
    margin-right: auto;
}
.carousel__pagination {
    margin: auto !important;
}
</style>
